<script setup lang="ts">
import { ref } from 'vue'

import { useCustomerStore } from '@shared/global-store/stores/customer/customer'
import CustomerIcon from '@storefront-satch/components/organisms/navigation/icon/CustomerIcon.vue'
import LogoutPopOut from '@storefront-satch/components/organisms/navigation/meta/account/LogoutPopOut.vue'

const props = defineProps<{
  authorizationRedirectUri: string
}>()

const customerStore = useCustomerStore()

const isOpen = ref<boolean>(false)

const onClose = () => (isOpen.value = false)
const onClick = (event: MouseEvent) => {
  if (!customerStore.isAuthenticated) {
    return
  }

  event.preventDefault()
  isOpen.value = !isOpen.value
}
</script>

<template>
  <div class="flex lg:relative">
    <a
      class="flex items-center"
      :href="props.authorizationRedirectUri"
      @click="onClick"
    >
      <CustomerIcon
        class="size-5.5"
        :customer="customerStore.customer ?? undefined"
      />
    </a>

    <LogoutPopOut
      v-if="isOpen"
      class="lg:bg-gray-nav top-12 bg-white lg:top-full lg:translate-y-1"
      backdrop-class="top-12 lg:translate-y-1"
      :is-open="isOpen"
      @close="onClose"
    />
  </div>
</template>
